import React, { memo, Suspense, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { deleteTimeLineItem } from '../../../../../store/timeline/actions'
import {
  ActivityTimelineContextProps,
  ActivityTimeline,
  ActivityTimelineContext,
  selectTimelineIsLoading,
  selectTimelineError,
} from '../../../../../components/v2/activity-timeline'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'
import { selectFilteredTimelineFiles } from '../../selectors'

const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

interface AppealsFilesTimelineProps {
  className?: string
  id: string | number
}

export const AppealFiles: React.FC<AppealsFilesTimelineProps> = memo(
  (props: AppealsFilesTimelineProps) => {
    const { id, className } = props
    const dispatch = useAppDispatch()
    const timelineIsLoading = useSelector(selectTimelineIsLoading)
    const timelineError = useSelector(selectTimelineError)
    const timelineFiles = useSelector(selectFilteredTimelineFiles)
    const entityType = 'measurement'

    const deleteAppealsTimelineItem = useCallback(activityItem => {
      dispatch(deleteTimeLineItem(activityItem))
    }, [])

    const defaultProps = useMemo(
      (): ActivityTimelineContextProps => ({
        card_id: id,
        card_type: entityType,
        deleteTimelineItem: deleteAppealsTimelineItem,
      }),
      [id],
    )

    return (
      <FilesContainer>
        {/*
        <Suspense fallback={''}>
          <UploadFiles
            entityType={entityType}
            entityId={id}
            url={`/api/${entityType}/${id}/add-file`}
            method="POST"
          />
        </Suspense>
        */}
        <Suspense fallback={''}>
          <ActivityTimelineContext.Provider value={defaultProps}>
            <ActivityTimeline
              isLoading={timelineIsLoading}
              items={timelineFiles}
              error={timelineError}
              className={className}
              emptyMessage={'Нет прикрепленных файлов'}
            />
          </ActivityTimelineContext.Provider>
        </Suspense>
      </FilesContainer>
    )
  },
)
